import { MotifFormField, MotifInput, MotifLabel } from '@ey-xd/motif-react'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { updateExtraxtedText } from '../AnnotateSlice'
interface DateTimeProps {
  recordIndex: number;
  evidenceId: string;
  annotationTypeId?: string;
  dateAndTime: string[];
  pageNumber: number; // Added 'pageNumber' property
  evidenceAnnotationId?: string;
  originalRecord?: any;
}

export const DateTime: React.FC<DateTimeProps> = ({evidenceId,
  recordIndex, annotationTypeId, dateAndTime: dateAndTime, pageNumber, evidenceAnnotationId, originalRecord }) => {
    const dispatch = useDispatch()
  const [dateTimeDetails, setDateTimeDetails] = useState<string[]>(dateAndTime || [])
  useEffect(() => {
    setDateTimeDetails(dateAndTime || [])
  }, [dateAndTime])
  const handleUserGroupChange = (index: number, value: string) => {
    const updatedUserGroup = [...dateTimeDetails]
    updatedUserGroup[index] = value
    setDateTimeDetails(updatedUserGroup)
  }
  useEffect(() => {
  dispatch(
    updateExtraxtedText({
      evidenceId: evidenceId,
      recordIndex: recordIndex,
      annotationTypeId: annotationTypeId,
      extractedText: {dateAndTime:dateTimeDetails},
      pageNumber: pageNumber ? pageNumber : 1, // Use the provided pageNumber or default to 1
      evidenceAnnotationId: evidenceAnnotationId,
    })
  )
  },[dateTimeDetails])
  return (
    <div className="date-time-tab">
      {dateAndTime && (
        <MotifFormField role="group">
          <MotifLabel position={'out'}>
            {'Date & Time'}
          </MotifLabel>
          {dateTimeDetails.map((item, index) => {
            const origVal = Array.isArray(originalRecord) ? (originalRecord[index] ?? '') : (originalRecord?.dateAndTime?.[index] ?? '')
            return (
              <div key={index} className={(origVal !== '') && item !== origVal ? 'field-changed' : ''}>
                <MotifInput
                  id={`input-${index}`}
                  value={item}
                  aria-label="date-time-input"
                  onChange={(e) => handleUserGroupChange(index, e.target.value)}
                  hideClearButton
                />
              </div>
            )
          })}
        </MotifFormField>
      )}
    </div>
  )
}
